import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

/**
 * Hook que envía un pageview a GA4 cada vez que cambia la ruta.
 * Debe usarse dentro de un componente que esté dentro de <Router>.
 */
export function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    if (!import.meta.env.PROD || !import.meta.env.VITE_GA_MEASUREMENT_ID) return;
    ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
  }, [location]);
}
